import ajax from "./ajax";
const API_KEY = "ad0WwLLxhAODJzg58kmBqA9ys4j1";
export function requestProducts(query) {
  return ajax("/products", {
    query,
    API_KEY,
  });
}

export function requestProductsCsv(query) {
  return ajax("/products/csv-download", { query });
}

export function assignProductsFulfillmentLocation(data) {
  return ajax("/products/fulfillment-location", { method: "POST", data });
}

export function deleteProducts(id) {
  return ajax(`/products/${id}`, { method: "DELETE" });
}

export function requestProductsCount(query) {
  return ajax("/counts/products");
}

export function requestProductDetails(id, query) {
  if (query) {
    return ajax(`/products/${id}?${query}`);
  }
  return ajax(`/products/${id}`);
}
export function requestImportProduct(id, shopId) {
  const platformProductId = encodeURIComponent(id);
  const shop = encodeURIComponent(shopId || "");
  return ajax(
    `/products/sync/${platformProductId}?shopId=${shop}&platformProductId=${platformProductId}`,
    {
      method: "PUT",
      server: "python",
    }
  );
}
export function requestProductMapping(id, query) {
  if (query) {
    return ajax(`/products/${id}/mapping?${query}`);
  }
  return ajax(`/products/${id}/mapping`);
}

export function requestProductMappingImages(id, query) {
  if (query) {
    return ajax(`/products/${id}/mapping/images?${query}`);
  }
  return ajax(`/products/${id}/mapping/images`);
}

export function requestListingActivity(id) {
  return ajax(`/products/${id}/activity`);
}

export function saveProductMapping(id, data) {
  return ajax(`/products/${id}/mapping`, { method: "POST", data });
}

export function getListingOpenItemCount(id, variantIds = []) {
  const ids = (variantIds || []).filter(Boolean).join(",");
  const query = ids ? `?variantIds=${encodeURIComponent(ids)}` : "";
  return ajax(`/products/${id}/mapping/open-items${query}`);
}

export function getListingPreSale(id) {
  return ajax(`/products/${id}/presale`);
}

export function setListingPreSale(id, preSale, preSaleScope) {
  return ajax(`/products/${id}/presale`, {
    method: "PUT",
    data: { preSale, ...(preSaleScope ? { preSaleScope } : {}) },
  });
}

export function releaseListingPreSale(id, mode, extra = {}) {
  return ajax(`/products/${id}/presale/release`, {
    method: "POST",
    data: { mode, ...extra },
  });
}

export function getManualPreSale(id) {
  return ajax(`/products/manual/${id}/presale`);
}

export function setManualPreSale(id, preSale, preSaleScope) {
  return ajax(`/products/manual/${id}/presale`, {
    method: "PUT",
    data: { preSale, ...(preSaleScope ? { preSaleScope } : {}) },
  });
}

export function releaseManualPreSale(id, mode) {
  return ajax(`/products/manual/${id}/presale/release`, {
    method: "POST",
    data: { mode },
  });
}

export function setPreSaleBulk(data) {
  return ajax(`/products/presale/bulk`, { method: "POST", data });
}

export function saveListingBlankInstances(id, data) {
  return ajax(`/products/${id}/blank-instances`, { method: "PUT", data });
}

export function bulkIgnoreProducts(data) {
  return ajax(`/products/bulk-ignore`, { method: "POST", data });
}

export function getBulkIgnoreStatus(jobId) {
  return ajax(`/products/bulk-ignore/${jobId}`);
}

export function postManualProduct(data) {
  return ajax(`/products/new`, { method: "POST", data, server: "python" });
}

export function postManualCsvProduct(data) {
  return ajax(`/products/new/csv`, { method: "POST", data, server: "python" });
}

export function requestManualProducts(query) {
  return ajax("/products/manual", { query });
}

// `toggleProductInventory` was removed when the per-product inventory
// toggle was retired in favour of per-variant `stockingEnabled` managed
// from the Inventory section. The endpoint may still exist server-side
// but should not be called from the UI.

export function requestManualProductDetails(id) {
  return ajax(`/products/manual/${id}`);
}

export function updateManualProductName(id, data) {
  return ajax(`/products/manual/${id}/name`, { method: "PUT", data });
}

export function transferManualProducts(data) {
  return ajax("/products/manual/transfer", { method: "POST", data });
}

export function setDiscountPriceAndPlacements(data) {
  return ajax("/settings/placements", { method: "PUT", data });
}

export function requestBlankProductColors(query) {
  return ajax("/blank-products/colors", { query });
}

export function saveListingMappingToDraft(id, data) {
  return ajax(`/products/${id}/mapping/draft`, { method: "POST", data });
}

export function getListingMappingToDraft(id) {
  return ajax(`/products/${id}/mapping/draft`);
}

export function saveListingTemplate(data) {
  return ajax(`/products/templates`, { method: "POST", data });
}

export function getListingTemplate(query) {
  return ajax(`/products/templates`, { query });
}

export function deleteListingTemplate(id) {
  return ajax(`/products/templates/${id}`, { method: "DELETE" });
}

export function syncListings(id) {
  return ajax(`/products/sync`, { server: "python" });
}

// Removes listings from the app (archived server-side). The store's own
// products and products under My Products are not touched.
export function removeListings(listingIds) {
  return ajax(`/products/listings/remove`, {
    method: "POST",
    data: { listingIds },
    server: "python",
  });
}

export function startMoveAllToAppLocation(data) {
  return ajax(`/v2/shopify/migrate-all-products`, {
    method: "POST",
    data,
    server: "python",
  });
}

export function getMoveAllToAppLocationStatus(jobId, query = {}) {
  return ajax(`/v2/shopify/migrate-all-products/status`, {
    query: {
      ...query,
      ...(jobId ? { jobId } : {}),
    },
    server: "python",
  });
}

export function getAllVariantsCost(id, query) {
  return ajax(`/products/${id}/variant-cost`, { query });
}

export function getSingleVariantCost(data) {
  return ajax(`/products/variant-cost`, { method: "POST", data });
}

export function getMultipleBlankVariantCosts(data) {
  return ajax(`/products/get-multiple-blank-variant-costs`, {
    method: "POST",
    data,
  });
}

/**
 * External ids (ERP item numbers, keyed by system) and units per case for
 * one variant mapping. `externalIds` merges; a null value removes a key.
 */
export function saveVariantExternalIds(productId, variantId, data) {
  return ajax(
    `/products/${encodeURIComponent(productId)}/variants/${encodeURIComponent(
      variantId
    )}/external-ids`,
    { method: "PUT", data }
  );
}
